import { AxiosResponse } from 'axios';
import { UserNotification } from '../../types/notifications';
import api from './client';

export const notificationService = {
  list: (
    limit: number = 20,
    offset: number = 0,
  ): Promise<AxiosResponse<UserNotification[]>> => {
    return api.get('/notifications', { params: { limit, offset } });
  },

  unreadCount: (): Promise<AxiosResponse<{ count: number }>> => {
    return api.get('/notifications/unread-count');
  },

  markRead: (id: number): Promise<AxiosResponse<void>> => {
    return api.post(`/notifications/${id}/read`);
  },

  markAllRead: (): Promise<AxiosResponse<void>> => {
    return api.post('/notifications/mark-all-read');
  },
};
